import React from 'react';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import { Grid } from 'antd';
import ServicePlusListDesktop from './Desktop';
import ServicePlusListMobile from './Mobile';
const { useBreakpoint } = Grid;

function GetBreakPoint() {
  const screens = useBreakpoint()
  return screens;
}

export default function ServicePlusListCondition(props) {
  const { lg } = GetBreakPoint()

  if(process.env.REACT_APP_ENV === "production"){
    ReactGA.pageview(`${window.location.pathname}${window.location.search}`, [], 'Service Plus - List');
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Service Plus - List</title>
      </Helmet>
      {
        lg ?
          <ServicePlusListDesktop {...props} />
        :
          <ServicePlusListMobile {...props} />
      }
    </React.Fragment>
  )
}
